<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_person_involve_add === true">เพิ่ม{{ type_open_person_involve == 1 ? 'ทุน' : type_open_person_involve == 2 ? 'เจ้าหนี้' : 'ลูกหนี้' }}เรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_person_involve_edit === true">แก้ไข{{ type_open_person_involve == 1 ? 'ทุน' : type_open_person_involve == 2 ? 'เจ้าหนี้' : 'ลูกหนี้' }}เรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_account_type_add === true">เพิ่มประเภทบัญชีเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_account_type_edit === true">แก้ไขประเภทบัญชีเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_account_type_status === true">เปลี่ยนสถานะเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>

    <v-card>

        <v-tabs grow>
            <v-tab @click="page(1)">บุคคลเกี่ยวข้อง</v-tab>
            <v-tab @click="page(2)">หมวดบัญชี</v-tab>
            <v-tab @click="page(3)">ประเภทบัญชี</v-tab>
        </v-tabs>

        <!-- บุคคลเกี่ยวข้อง -->
        <div class="pa-3" v-if="title_type_account_setting === 1">
            <div v-if="loading_person_involve_page === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <div v-if="loading_person_involve_page === false">
                <div class="mb-5 d-flex justify-space-between">
                    <h2>กำหนดบุคคลที่เกี่ยวข้อง</h2>
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn width="20%" color="#28ab28" class="white--text" height="50" v-bind="attrs" v-on="on">
                                <div class="d-flex justify-space-between align-center add_account_setting_list">
                                    <div>เพิ่ม</div>
                                    <div>
                                        <v-icon>mdi-menu-down</v-icon>
                                    </div>
                                </div>

                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item link @click="openAddPersonInvolve(1)">
                                <v-list-item-title class="add_account_setting_list">ทุน</v-list-item-title>
                            </v-list-item>
                            <v-list-item link @click="openAddPersonInvolve(2)">
                                <v-list-item-title class="add_account_setting_list">เจ้าหนี้</v-list-item-title>
                            </v-list-item>
                            <v-list-item link @click="openAddPersonInvolve(3)">
                                <v-list-item-title class="add_account_setting_list">ลูกหนี้</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
                <div class="list_account_setting_list justify-space-between">
                    <div>
                        <v-card class="pa-3 mb-3">
                            <v-card class="d-flex align-center icon_list_account_setting_list" color="primary">
                                <v-icon size="40">mdi-cash-multiple</v-icon>
                            </v-card>
                            <div class="text-right">
                                <div>บาท</div>
                                <h3>{{ Intl.NumberFormat().format(capital_sum) }}</h3>
                            </div>
                            <hr>
                            <div>ทุน</div>
                        </v-card>
                    </div>
                    <div>
                        <v-card class="pa-3 mb-3">
                            <v-card class="d-flex align-center icon_list_account_setting_list" color="primary">
                                <v-icon size="40">mdi-cash-multiple</v-icon>
                            </v-card>
                            <div class="text-right">
                                <div>บาท</div>
                                <h3>{{ Intl.NumberFormat().format(creditor_sum) }}</h3>
                            </div>
                            <hr>
                            <div>เจ้าหนี้</div>
                        </v-card>
                    </div>
                    <div>
                        <v-card class="pa-3 mb-3">
                            <v-card class="d-flex align-center icon_list_account_setting_list" color="primary">
                                <v-icon size="40">mdi-cash-multiple</v-icon>
                            </v-card>
                            <div class="text-right">
                                <div>บาท</div>
                                <h3>{{ Intl.NumberFormat().format(debtor_sum) }}</h3>
                            </div>
                            <hr>
                            <div>ลูกหนี้</div>
                        </v-card>
                    </div>
                </div>
                <div class="list_account_setting_list justify-space-between">
                    <div>
                        <v-card class="pa-3 detail_account_setting_list">
                            <div class="pa-3">
                                <div class="d-flex justify-space-between">
                                    <div>#รายการ</div>
                                    <div>ยอด</div>
                                </div>
                            </div>
                            <div class="pa-3" v-for="(capital_detail,index) in capital_list" :key="index">
                                <div class="d-flex justify-space-between">
                                    <div class="cursor_account_setting_list" @click="openEditPersonInvolve(1,capital_detail.id)">{{ capital_detail.capital_name }}</div>
                                    <div>{{ Intl.NumberFormat().format(capital_detail.capital_price) }}</div>
                                </div>
                                <hr>
                            </div>
                        </v-card>
                    </div>
                    <div>
                        <v-card class="pa-3 detail_account_setting_list">
                            <div class="pa-3">
                                <div class="d-flex justify-space-between">
                                    <div>#รายการ</div>
                                    <div>ยอด</div>
                                </div>
                            </div>
                            <div class="pa-3" v-for="(creditor_detail,index) in creditor_list" :key="index">
                                <div class="d-flex justify-space-between">
                                    <div class="cursor_account_setting_list" @click="openEditPersonInvolve(2,creditor_detail.id)">{{ creditor_detail.creditor_name }}</div>
                                    <div>{{ Intl.NumberFormat().format(creditor_detail.creditor_price) }}</div>
                                </div>
                                <hr>
                            </div>
                        </v-card>
                    </div>
                    <div>
                        <v-card class="pa-3 detail_account_setting_list">
                            <div class="pa-3">
                                <div class="d-flex justify-space-between">
                                    <div>#รายการ</div>
                                    <div>ยอด</div>
                                </div>
                            </div>
                            <div class="pa-3" v-for="(debtor_detail,index) in debtor_list" :key="index">
                                <div class="d-flex justify-space-between">
                                    <div class="cursor_account_setting_list" @click="openEditPersonInvolve(3,debtor_detail.id)">{{ debtor_detail.debtor_name }}</div>
                                    <div>{{ Intl.NumberFormat().format(debtor_detail.debtor_price) }}</div>
                                </div>
                                <hr>
                            </div>
                        </v-card>
                    </div>
                </div>
                <!-- เพิ่ม -->
                <v-dialog v-model="open_add_person_involve" persistent max-width="600px">
                    <v-card>
                        <v-form ref="form_person_involve" @submit.prevent="addPersonInvolve()">
                            <v-card-title class="justify-space-between">
                                <div>
                                    เพิ่ม{{ type_open_person_involve == 1 ? 'ทุน' : type_open_person_involve == 2 ? 'เจ้าหนี้' : type_open_person_involve == 3 ? 'ลูกหนี้' : '' }}
                                </div>
                                <div class="cursor_account_setting_list" @click="open_add_person_involve = false">
                                    <v-icon>mdi-close</v-icon>
                                </div>
                            </v-card-title>

                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" v-if="type_open_person_involve == 1">
                                            <v-text-field label="ผู้ลงทุน" v-model="capital_input.capital_name" :rules="[v => !!v || 'กรุณากรอกผู้ลงทุน']" required outlined></v-text-field>
                                        </v-col>
                                        <v-col cols="12" v-if="type_open_person_involve == 2">
                                            <v-text-field label="เจ้าหนี้" v-model="creditor_input.creditor_name" :rules="[v => !!v || 'กรุณากรอกเจ้าหนี้']" required outlined></v-text-field>
                                        </v-col>
                                        <v-col cols="12" v-if="type_open_person_involve == 3">
                                            <v-text-field label="ลูกหนี้" v-model="debtor_input.debtor_name" :rules="[v => !!v || 'กรุณากรอกลูกหนี้']" required outlined></v-text-field>
                                            <v-text-field label="ค่าบริการ (%)" type="number" v-model="debtor_input.service_charge" :rules="[v => !!v || 'กรุณากรอกค่าบริการ (%)']" required outlined></v-text-field>
                                            <v-text-field label="VAT (%)" type="number" v-model="debtor_input.vat" :rules="[v => !!v || 'กรุณากรอกVAT (%)']" required outlined></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions class="justify-center">
                                <v-btn color="#28ab28" class="white--text" height="50" width="50%" type="submit">
                                    บันทึก
                                </v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-dialog>
                <!-- แก้ไข -->
                <v-dialog v-model="open_edit_person_involve" persistent max-width="600px">
                    <div v-if="loading_person_involve_detail_page === true">
                        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                        </v-sheet>
                    </div>
                    <v-card v-if="loading_person_involve_detail_page === false">
                        <v-form ref="form_person_involve_edit" @submit.prevent="editPersonInvolve()">
                            <v-card-title class="justify-space-between">
                                <div>
                                    แก้ไข{{ type_open_person_involve == 1 ? 'ทุน' : type_open_person_involve == 2 ? 'เจ้าหนี้' : type_open_person_involve == 3 ? 'ลูกหนี้' : '' }}
                                </div>
                                <div class="cursor_account_setting_list" @click="open_edit_person_involve = false">
                                    <v-icon>mdi-close</v-icon>
                                </div>
                            </v-card-title>

                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" v-if="type_open_person_involve == 1">
                                            <v-text-field label="ผู้ลงทุน" v-model="capital_input.capital_name" :rules="[v => !!v || 'กรุณากรอกผู้ลงทุน']" required outlined></v-text-field>
                                        </v-col>
                                        <v-col cols="12" v-if="type_open_person_involve == 2">
                                            <v-text-field label="เจ้าหนี้" v-model="creditor_input.creditor_name" :rules="[v => !!v || 'กรุณากรอกเจ้าหนี้']" required outlined></v-text-field>
                                        </v-col>
                                        <v-col cols="12" v-if="type_open_person_involve == 3">
                                            <v-text-field label="ลูกหนี้" v-model="debtor_input.debtor_name" :rules="[v => !!v || 'กรุณากรอกลูกหนี้']" required outlined></v-text-field>
                                            <v-text-field label="ค่าบริการ (%)" type="number" v-model="debtor_input.service_charge" :rules="[v => !!v || 'กรุณากรอกค่าบริการ (%)']" required outlined></v-text-field>
                                            <v-text-field label="VAT (%)" type="number" v-model="debtor_input.vat" :rules="[v => !!v || 'กรุณากรอกVAT (%)']" required outlined></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions class="justify-center">
                                <v-btn color="#28ab28" class="white--text" height="50" width="50%" type="submit">
                                    บันทึก
                                </v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-dialog>
            </div>
        </div>
        <!-- หมวดบัญชี -->
        <div v-if="title_type_account_setting === 2">
            <div v-if="loading_category_account_page === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <div v-if="loading_category_account_page === false">
                <div class="pa-3 mb-2">
                    <h2>รายการหมวดบัญชี</h2>
                </div>
                <v-card-title>
                    <v-text-field v-model="search_category_account" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers_category_account" :items="data_category_account" :search="search_category_account">
                    <template v-slot:item="dataDetail">
                        <tr>
                            <td width="10%">{{dataDetail.item.number}}</td>
                            <td width="20%">{{dataDetail.item.ac_groups_name}}</td>
                            <td width="70%">{{dataDetail.item.description === null || dataDetail.item.description === '' ? '-' : dataDetail.item.description}}</td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
        </div>
        <!-- ประเภทบัญชี -->
        <div v-if="title_type_account_setting === 3">
            <div v-if="loading_type_account_page === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <div v-if="loading_type_account_page === false">
                <div class="pa-3 mb-2">
                    <h2>กำหนดประเภทบัญชี</h2>
                    <div class="text-right">
                        <v-btn color="#28ab28" class="white--text" @click="openAddTypeAccount()" width="20%" height="65">
                            เพิ่มประเภทบัญชี
                        </v-btn>
                    </div>
                </div>
                <div class="pa-3 mb-2">
                    <p class="error--text">หมายเหตุ ประเภทบัญชีที่ระบบทำรายการอัตโนมัติจะไม่สามารถแก้ไขหรือเปลี่ยนสถานะได้</p>
                </div>
                <v-card-title>
                    <v-text-field v-model="search_type_account" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers_type_account" :items="data_type_account" :search="search_type_account">
                    <template v-slot:item="dataDetail">
                        <tr>
                            <td>{{dataDetail.item.number}}</td>
                            <td>{{dataDetail.item.ac_type_name}}</td>
                            <td>{{dataDetail.item.ac_group_name}}</td>
                            <td>
                                <span v-if="dataDetail.item.id == 2 || dataDetail.item.id == 4 || dataDetail.item.id == 5 || dataDetail.item.id == 6 || dataDetail.item.id == 7 || dataDetail.item.id == 8 || dataDetail.item.id == 9 || dataDetail.item.id == 14 || dataDetail.item.id == 10 || dataDetail.item.id == 15">
                                    -
                                </span>
                                <span v-else>
                                    <v-switch color="success" v-model="dataDetail.item.status" @click="changeStatusAccountType(dataDetail.item.id)"></v-switch>
                                </span>
                            </td>
                            <td>
                                <span class="cursor_account_setting_list" @click="detailAccountType(dataDetail.item.id)">
                                    <v-icon right color="grey">mdi-pencil-box-outline</v-icon>
                                </span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
                <v-dialog v-model="open_add_type_account" persistent max-width="600px">
                    <v-card>
                        <v-form ref="form_account_type" @submit.prevent="addAccountType()">

                            <v-card-title class="justify-space-between">
                                <div>
                                    เพิ่มประเภทบัญชี
                                </div>
                                <div class="cursor_account_setting_list" @click="open_add_type_account = false">
                                    <v-icon>mdi-close</v-icon>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-select label="เลือกหมวดบัญชี" v-model="type_account_input.ac_group_id" :items="data_category_account" item-text="ac_groups_name" item-value="id" :rules="[v => !!v || 'กรุณาเลือกหมวดบัญชี']" required outlined>
                                            </v-select>
                                            <v-text-field label="ชื่อประเภทบัญชี" v-model="type_account_input.ac_type_name" :rules="[v => !!v || 'กรุณากรอกชื่อประเภทบัญชี']" required outlined></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions class="justify-center">
                                <v-btn color="#28ab28" class="white--text" height="50" width="50%" type="submit">
                                    บันทึก
                                </v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="open_edit_type_account" persistent max-width="600px">
                    <div v-if="loading_edit_type_account_page === true">
                        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                        </v-sheet>
                    </div>
                    <v-card v-if="loading_edit_type_account_page === false">
                        <v-form ref="form_edit_account_type" @submit.prevent="editAccountType()">

                            <v-card-title class="justify-space-between">
                                <div>
                                    แก้ไขประเภทบัญชี
                                </div>
                                <div class="cursor_account_setting_list" @click="open_edit_type_account = false">
                                    <v-icon>mdi-close</v-icon>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-select label="เลือกหมวดบัญชี" v-model="type_account_input.ac_group_id" :items="data_category_account" item-text="ac_groups_name" item-value="id" :rules="[v => !!v || 'กรุณาเลือกหมวดบัญชี']" required outlined>
                                            </v-select>
                                            <v-text-field label="ชื่อประเภทบัญชี" v-model="type_account_input.ac_type_name" :rules="[v => !!v || 'กรุณากรอกชื่อประเภทบัญชี']" required outlined></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions class="justify-center">
                                <v-btn color="#28ab28" class="white--text" height="50" width="50%" type="submit">
                                    บันทึก
                                </v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-dialog>
            </div>
        </div>
    </v-card>
</div>
</template>

<script>
import assignrelevantpeopleall from '@/api/account/accountsetting/assignrelevantpeopleall.js'
import accountcategory from '@/api/account/accountsetting/accountcategory.js'
import accounttype from '@/api/account/accountsetting/accounttype.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            title_type_account_setting: 1,
            // 1 บุคคลเกี่ยวข้อง
            loading_person_involve_page: true,
            loading_person_involve_detail_page: true,
            alert_show_person_involve_add: false,
            alert_show_person_involve_edit: false,
            open_add_person_involve: false,
            open_edit_person_involve: false,
            type_open_person_involve: null,
            edit_person_involve_id: null,
            capital_sum: null,
            capital_list: [],
            capital_input: {
                capital_name: null,
            },
            creditor_sum: null,
            creditor_list: [],
            creditor_input: {
                creditor_name: null,
            },
            debtor_sum: null,
            debtor_list: [],
            debtor_input: {
                debtor_name: null,
                service_charge: null,
                vat: null,
            },
            // 2 หมวดบัญชี
            loading_category_account_page: true,
            search_category_account: '',
            headers_category_account: [{
                    text: '#',
                    align: 'start',
                    value: 'number',
                },
                {
                    text: 'ชื่อหมวดบัญชี',
                    value: 'ac_groups_name'
                },
                {
                    text: 'หมายเหตุ',
                    value: 'description'
                },

            ],
            data_category_account: [],
            // 3 ประเภทบัญชี
            loading_type_account_page: true,
            loading_edit_type_account_page: true,
            alert_show_account_type_add: false,
            alert_show_account_type_edit: false,
            alert_show_account_type_status: false,
            open_add_type_account: false,
            open_edit_type_account: false,
            search_type_account: '',
            headers_type_account: [{
                    text: '#',
                    align: 'start',
                    value: 'number',
                },
                {
                    text: 'ชื่อประเภทบัญชี',
                    value: 'ac_type_name'
                },
                {
                    text: 'หมวดบัญชี',
                    value: 'ac_group_name'
                },
                {
                    text: 'สถานะ',
                    value: 'status'
                },
                {
                    text: 'จัดการ',
                    value: 'action'
                },

            ],
            data_type_account: [],
            edit_type_account_id: null,
            type_account_input: {
                ac_group_id: null,
                ac_type_name: null,
            },
        }
    },
    methods: {
        async page(type) {
            this.title_type_account_setting = type
            if (this.title_type_account_setting == 1) {
                this.assignRelevantPeople()
            }
            if (this.title_type_account_setting == 2) {
                this.accountCategoryList()
            }
            if (this.title_type_account_setting == 3) {
                this.accountTypeList()
            }
        },
        // 1 บุคคลเกี่ยวข้อง
        async openAddPersonInvolve(type) {
            this.capital_input = {
                capital_name: null,
            }
            this.creditor_input = {
                creditor_name: null,
            }
            this.debtor_input = {
                debtor_name: null,
                service_charge: null,
                vat: null,
            }
            this.type_open_person_involve = type
            this.open_add_person_involve = true
        },
        async assignRelevantPeople() {
            this.loading_person_involve_page = true
            assignrelevantpeopleall.assignRelevantPeopleList().then((response) => {
                if (response.data.successful === true) {
                    this.capital_sum = response.data.capitalSum
                    this.capital_list = response.data.capitalList
                    this.creditor_sum = response.data.creditorSum
                    this.creditor_list = response.data.creditorList
                    this.debtor_sum = response.data.debtorSum
                    this.debtor_list = response.data.debtorList
                    this.loading_person_involve_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async addPersonInvolve() {
            if (this.$refs.form_person_involve.validate()) {
                this.open_add_person_involve = false
                this.loading_person_involve_page = true
                if (this.type_open_person_involve == 1) {
                    assignrelevantpeopleall.addCapital(this.capital_input).then((response) => {
                        if (response.data.successful === true) {
                            this.assignRelevantPeople()
                            this.alert_show_person_involve_add = true
                            setTimeout(() => this.alert_show_person_involve_add = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }
                if (this.type_open_person_involve == 2) {
                    assignrelevantpeopleall.addCreditor(this.creditor_input).then((response) => {
                        if (response.data.successful === true) {
                            this.assignRelevantPeople()
                            this.alert_show_person_involve_add = true
                            setTimeout(() => this.alert_show_person_involve_add = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }
                if (this.type_open_person_involve == 3) {
                    assignrelevantpeopleall.addDebtor(this.debtor_input).then((response) => {
                        if (response.data.successful === true) {
                            this.assignRelevantPeople()
                            this.alert_show_person_involve_add = true
                            setTimeout(() => this.alert_show_person_involve_add = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }

                this.capital_input = {
                    capital_name: null,
                }
                this.creditor_input = {
                    creditor_name: null,
                }
                this.debtor_input = {
                    debtor_name: null,
                    service_charge: null,
                    vat: null,
                }
            }
        },
        async openEditPersonInvolve(type, id) {
            this.loading_person_involve_detail_page = true
            this.edit_person_involve_id = null
            this.capital_input = {
                capital_name: null,
            }
            this.creditor_input = {
                creditor_name: null,
            }
            this.debtor_input = {
                debtor_name: null,
                service_charge: null,
                vat: null,
            }
            this.type_open_person_involve = type
            this.open_edit_person_involve = true
            if (type == 1) {
                assignrelevantpeopleall.detailCapital(id).then((response) => {
                    if (response.data.successful === true) {
                        this.edit_person_involve_id = response.data.capital.id
                        this.capital_input = {
                            capital_name: response.data.capital.capital_name,
                        }
                        this.loading_person_involve_detail_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
            if (type == 2) {
                assignrelevantpeopleall.detailCreditor(id).then((response) => {
                    if (response.data.successful === true) {
                        this.edit_person_involve_id = response.data.creditor.id
                        this.creditor_input = {
                            creditor_name: response.data.creditor.creditor_name,
                        }
                        this.loading_person_involve_detail_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })

            }
            if (type == 3) {
                assignrelevantpeopleall.detailDebtor(id).then((response) => {
                    if (response.data.successful === true) {
                        this.edit_person_involve_id = response.data.debtor.id
                        this.debtor_input = {
                            debtor_name: response.data.debtor.debtor_name,
                            service_charge: response.data.debtor.service_charge,
                            vat: response.data.debtor.vat,
                        }
                        this.loading_person_involve_detail_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })

            }

        },
        async editPersonInvolve() {
            if (this.$refs.form_person_involve_edit.validate()) {
                this.open_edit_person_involve = false
                this.loading_person_involve_page = true
                if (this.type_open_person_involve == 1) {
                    const data = {
                        capital_name:this.capital_input.capital_name,
                    }
                    assignrelevantpeopleall.editCapital(this.edit_person_involve_id,data).then((response) => {
                        if (response.data.successful === true) {
                            this.assignRelevantPeople()
                            this.alert_show_person_involve_edit = true
                            setTimeout(() => this.alert_show_person_involve_edit = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }
                if (this.type_open_person_involve == 2) {
                    const data = {
                        creditor_name:this.creditor_input.creditor_name,
                    }
                    assignrelevantpeopleall.editCreditor(this.edit_person_involve_id,data).then((response) => {
                        if (response.data.successful === true) {
                            this.assignRelevantPeople()
                            this.alert_show_person_involve_edit = true
                            setTimeout(() => this.alert_show_person_involve_edit = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }
                if (this.type_open_person_involve == 3) {
                    const data = {
                        debtor_name:this.debtor_input.debtor_name,
                        service_charge:this.debtor_input.service_charge,
                        vat:this.debtor_input.vat,
                    }
                    assignrelevantpeopleall.editDebtor(this.edit_person_involve_id,data).then((response) => {
                        if (response.data.successful === true) {
                            this.assignRelevantPeople()
                            this.alert_show_person_involve_edit = true
                            setTimeout(() => this.alert_show_person_involve_edit = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }
                this.edit_person_involve_id = null
                this.capital_input = {
                    capital_name: null,
                }
                this.creditor_input = {
                    creditor_name: null,
                }
                this.debtor_input = {
                    debtor_name: null,
                    service_charge: null,
                    vat: null,
                }
            }
        },
        // 2 หมวดบัญชี
        async accountCategoryList() {
            this.loading_category_account_page = true
            accountcategory.accountCategoryList().then((response) => {
                if (response.data.successful === true) {
                    this.data_category_account = response.data.list
                    response.data.list.forEach((detail, index) => {
                        this.data_category_account[index]['number'] = index + 1
                    })
                    this.loading_category_account_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        // 3 ประเภทบัญชี
        async accountTypeList() {
            this.loading_type_account_page = true
            await this.accountCategoryList()
            await accounttype.accountTypeList().then((response) => {
                if (response.data.successful === true) {
                    this.data_type_account = response.data.accountType
                    response.data.accountType.forEach((detail, index) => {
                        this.data_type_account[index]['number'] = index + 1
                    })
                    this.loading_type_account_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async openAddTypeAccount() {
            this.type_account_input = {
                ac_group_id: null,
                ac_type_name: null,
            }
            this.open_add_type_account = true
        },
        async addAccountType() {
            if (this.$refs.form_account_type.validate()) {
                this.open_add_type_account = false
                this.loading_type_account_page = true
                accounttype.addAccountType(this.type_account_input).then((response) => {
                    if (response.data.successful === true) {
                        this.accountTypeList()
                        this.alert_show_account_type_add = true
                        setTimeout(() => this.alert_show_account_type_add = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
                this.type_account_input = {
                    ac_group_id: null,
                    ac_type_name: null,
                }
            }
        },
        async changeStatusAccountType(id) {
            accounttype.changeStatusAccountType(id).then((response) => {
                if (response.data.successful === true) {
                    this.alert_show_account_type_status = true
                    setTimeout(() => this.alert_show_account_type_status = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async detailAccountType(id) {
            this.loading_edit_type_account_page = true
            this.open_edit_type_account = true
            accounttype.detailAccountType(id).then((response) => {
                if (response.data.successful === true) {
                    this.edit_type_account_id = response.data.accountType.id
                    this.type_account_input = {
                        ac_group_id: response.data.accountType.ac_group_id,
                        ac_type_name: response.data.accountType.ac_type_name,
                    }
                    this.loading_edit_type_account_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async editAccountType() {
            if (this.$refs.form_edit_account_type.validate()) {
                this.open_edit_type_account = false
                this.loading_edit_type_account_page = true
                this.loading_type_account_page = true
                accounttype.editAccountType(this.edit_type_account_id, this.type_account_input).then((response) => {
                    if (response.data.successful === true) {
                        this.accountTypeList()
                        this.alert_show_account_type_edit = true
                        setTimeout(() => this.alert_show_account_type_edit = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
                this.edit_type_account_id = null
                this.type_account_input = {
                    ac_group_id: null,
                    ac_type_name: null,
                }
            }
        },
    },
    mounted() {
        this.page(this.title_type_account_setting)
    },
}
</script>

<style scoped>
.add_account_setting_list {
    width: 100%;
    font-size: 22px;
}

.add_account_setting_list>div:first-child {
    width: 90%;
}

.add_account_setting_list>div:last-child {
    width: 10%;
}

.cursor_account_setting_list {
    cursor: pointer;
}

.list_account_setting_list {
    display: grid;
    grid-template-columns: 30% 30% 30%;
}

.icon_list_account_setting_list {
    padding: 15px;
    border-radius: 4px !important;
    position: absolute !important;
    top: -22px;
    left: 10px;
}

.icon_list_account_setting_list>i {
    color: #fff !important;
}

.detail_account_setting_list {
    height: 100%;
}
</style>
